import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum, IsNotEmpty } from "class-validator";

export class FreightAfterShipmentDto{
    @ApiProperty()
    freightAfterShipment:string;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    updatedUser?:string;
    // @ApiProperty()
    // containerId?:number;

    /**
     * 
    
     * 
     *
     * @param freightAfterShipment 
     * @param createdUser 
     * @param containerId 
     * @param updatedUser 
     */
    constructor( freightAfterShipment:string, createdUser:string,saleOrderId?:number, updatedUser?:string){
this.freightAfterShipment=freightAfterShipment
        // this.containerId = containerId;
        this.saleOrderId=saleOrderId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
    }
}